<template>
    <el-popconfirm v-if='hasPerms(perms)' :title='title' @onConfirm="handleConfirm" confirm-button-text='确 定' cancel-button-text='取 消'>
        <el-link :size='size' slot="reference" :icon='icon' :type='type'></el-link>
    </el-popconfirm>
</template>

<script>
import {
    hasPermission,
} from '@/utils/auth';

export default {
    name: 'DConfirmIcon',
    props: {
        label: { // 显示文本
            type: String,
            default: 'Link',
        },
        icon: { // 显示文本
            type: String,
            default: 'el-icon-edit',
        },
        title: { // 确认框提示内容
            type: String,
            default: 'title',
        },
        size: { // 按钮尺寸
            type: String,
            default: 'mini',
        },
        type: { // 按钮类型
            type: String,
            default: null,
        },
        // loading: { // 按钮加载标识
        //   type: Boolean,
        //   default: false,
        // },
        disabled: { // 按钮是否禁用
            type: Boolean,
            default: false,
        },
        perms: { // 按钮权限标识，外部使用者传入
            type: String,
            default: null,
        },
    },
    data() {
        return {};
    },
    methods: {
        handleConfirm() {
            // 按钮操作处理函数
            this.$emit('onConfirm', {});
        },
        hasPerms(perms) {
            //   return false;
            if (perms !== null && perms !== '') {
                return hasPermission(this.$route.path, perms) && !this.disabled;
            }
            return true;
            // 根据权限标识和外部指示状态进行权限判断
            //   return hasPermission(perms) && !this.disabled;
        },
    },
    mounted() {},
};
</script>


<style>
.el-popconfirm__main {
    white-space: pre-line;
    margin: -14px 0 4px;
}

.el-popconfirm__main>i {
    margin-top: 22px;
    margin-bottom: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Confirm/DConfirmIcon.vue